/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mascot_Chat_Ph_EmailInputs */

const tr_mascot_chat_ph_email = /** @type {(inputs: Mascot_Chat_Ph_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-posta`)
};

const en_mascot_chat_ph_email = /** @type {(inputs: Mascot_Chat_Ph_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Email`)
};

const de_mascot_chat_ph_email = /** @type {(inputs: Mascot_Chat_Ph_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-Mail`)
};

const ru_mascot_chat_ph_email = /** @type {(inputs: Mascot_Chat_Ph_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`E-mail`)
};

/**
* | output |
* | --- |
* | "Email" |
*
* @param {Mascot_Chat_Ph_EmailInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mascot_chat_ph_email = /** @type {((inputs?: Mascot_Chat_Ph_EmailInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mascot_Chat_Ph_EmailInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mascot_chat_ph_email(inputs)
	if (locale === "de") return de_mascot_chat_ph_email(inputs)
	if (locale === "ru") return ru_mascot_chat_ph_email(inputs)
	return tr_mascot_chat_ph_email(inputs)
});